import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField, Chip, Box } from '@mui/material';

const FinancialYearSelect = ({ onSelect }) => {
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState([]);


  const generateFinancialYears = () => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth(); 
    let startYear = currentMonth >= 9 ? currentYear+1 : currentYear;

    const years = [];
    // last 6 years from curent year
    for (let i = 0; i < 6; i++) {
      const fyLabel = `FY-${startYear}`;
      const fyValue = `${startYear % 100}`; 
      years.push({ label: fyLabel, value: fyValue });
      startYear--;
    }
    setOptions(years);

    setSelected([years[0], years[1]]);
    onSelect([years[0].value, years[1].value]);
  };

  useEffect(() => {
    generateFinancialYears();
  }, []);


  const handleChange = (event, newValue) => {
    if (newValue.length === 0) return;
    setSelected(newValue);
    onSelect(newValue.map((item) => item.value));
  };

  return (
    <Autocomplete
      multiple
      options={options}
      getOptionLabel={(option) => option.label}
      value={selected}
      onChange={handleChange}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            key={option.value}
            label={option.label}
            {...getTagProps({ index })}
            size='small'
          />
        ))
      }
      renderInput={(params) => (
        <TextField {...params} variant="outlined" label="Select Financial Years" 
          size='small'
        />
      )}
      sx={{
        width: 370, 
        '.MuiAutocomplete-inputRoot': {
        //   flexWrap: 'nowrap', 
        },
        '.MuiAutocomplete-tag': {
          margin: '2px', 
        },
      }}
      size='small'
    />
  );
};

export default FinancialYearSelect;
